// Anglar
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// Layout Directives
import { DirectiveV1Module } from '@app/shared/directive-v1.module';
import { FeatureModule } from 'v2/shared/feature/feature.module';

import {
  ContentAnimateDirective,
  HeaderDirective,
  MenuDirective,
  StickyDirective,
} from './_base/layout';
// Pipes
// Services
import {
  FirstLetterPipe,
  GetObjectPipe,
  JoinPipe,
  OffcanvasDirective,
  SafePipe,
  ScrollTopDirective,
  SparklineChartDirective,
  TabClickEventDirective,
  TimeElapsedPipe,
  ToggleDirective,
  FilterField,
  UnitConversionRuleSkuNamePipe,
} from './_base/layout';
import { KeyPressTableDirective } from './_base/layout/directives/key-press-table/key-press-table.directive';
import { CostFormatPipe } from './_base/layout/pipes/cost-format.pipe';
import { CustomDateTimePipe } from './_base/layout/pipes/custom-date-time.pipe';
import { LocalDatePipe } from './_base/layout/pipes/local-date.pipe';
import { PricingCalculationPipe } from './_base/layout/pipes/pricing-calculation.pipe';
import { PricingHasOverridePipe } from './_base/layout/pipes/pricing-has-override.pipe';
import { PricingOrderAmountPipe } from './_base/layout/pipes/pricing-order-amount.pipe';
import { PricingOverridePipe } from './_base/layout/pipes/pricing-override.pipe';
import { SortByDatePipe } from './_base/layout/pipes/sort-by-date.pipe';
import { SortByPipe } from './_base/layout/pipes/sort-by.pipe';
import { TransformAddressPipe } from './_base/layout/pipes/transform-address.pipe';
import { VersionCheckService } from './_base/layout/services/version-check.service';
import { TrackstarConnectButtonComponent } from './trackstar/trackstar-connect-button/trackstar-connect-button.component';

@NgModule({
  imports: [CommonModule, DirectiveV1Module, FeatureModule],
  declarations: [
    // directives
    ScrollTopDirective,
    HeaderDirective,
    OffcanvasDirective,
    ToggleDirective,
    MenuDirective,
    TabClickEventDirective,
    SparklineChartDirective,
    ContentAnimateDirective,
    StickyDirective,
    // pipes
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    SafePipe,
    FirstLetterPipe,
    FilterField,
    SortByDatePipe,
    UnitConversionRuleSkuNamePipe,
    KeyPressTableDirective,
    SortByPipe,
    PricingCalculationPipe,
    PricingOrderAmountPipe,
    PricingOverridePipe,
    PricingHasOverridePipe,
    TransformAddressPipe,
    CustomDateTimePipe,
    TrackstarConnectButtonComponent,
    CostFormatPipe,
    LocalDatePipe,
  ],
  exports: [
    // directives
    ScrollTopDirective,
    HeaderDirective,
    OffcanvasDirective,
    ToggleDirective,
    MenuDirective,
    TabClickEventDirective,
    SparklineChartDirective,
    ContentAnimateDirective,
    StickyDirective,
    // pipes
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    SafePipe,
    FirstLetterPipe,
    FilterField,
    SortByDatePipe,
    UnitConversionRuleSkuNamePipe,
    KeyPressTableDirective,
    SortByPipe,
    PricingCalculationPipe,
    PricingOrderAmountPipe,
    PricingOverridePipe,
    PricingHasOverridePipe,
    TransformAddressPipe,
    CustomDateTimePipe,
    LocalDatePipe,
    CostFormatPipe,
    TrackstarConnectButtonComponent,
  ],
  providers: [VersionCheckService],
})
export class CoreModule {}
